import Done from './Done';
import Prework from './Prework';
import Review from './Review';
import Reviewing from './Reviewing';
import Working from './Working';

const WorkState = {
  Prework,
  Working,
  Review,
  Reviewing,
  Done,
};

export default WorkState;
